module.exports = __webpack_public_path__ + "static/media/iem.ea1cad1b.gif";